import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMenu as _getMenu, getList, toSubmit, selectedPerson } from './data';
import { deteleObject } from './select.js';
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    modalKey: {
      type: String,
      default: ''
    },
    remindKey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      package_id: this.$route.query.package_id,
      // 清单id
      dialogTableVisible: false,
      pages: {},
      activeIndex: '2',
      menus: [],
      number: [],
      list: [],
      ids: [],
      tableList: [],
      // 暂存区人员
      selectArr: [],
      // 暂存区已选择人员
      tableList2: [],
      // 已选区人员
      seletedArr: [],
      // 已选区已选人员
      query: {
        username: null,
        organize_ids: [],
        page: 1
      }
    };
  },
  computed: {
    select_number: function select_number() {
      return this.tableList2.length;
    }
  },
  watch: {
    dialogTableVisible: function dialogTableVisible(newVal) {
      var _this = this;
      if (newVal) {
        _getMenu().then(function (res) {
          _this.menus = res.data;
        });
        // if (this.$route.query.edit && this.remindKey) {
        //   // this.leftQuery.modal_key = this.modalKey
        //   getRemindSeletedList({ modal_remind_key: this.remindKey, modal_key: this.modalKey }).then(res => {
        //     this.tableList2 = res.data
        //     this.list = res.data
        //   })
        // }
      }
    }
  },
  methods: {
    // 获取已选人员列表
    getDefaultData: function getDefaultData() {
      var _this2 = this;
      if (this.package_id) {
        selectedPerson({
          package_id: this.package_id
        }).then(function (res) {
          _this2.tableList2 = res.data;
        });
      }
    },
    // sizeChange(size) {
    //   this.query.pagesize = size
    //   this.getData()
    // },
    // currentChange(current) {
    //   this.query.page = current
    //   this.getData()
    // },
    deletePerson: function deletePerson() {
      var _this3 = this;
      this.tableList2 = this.tableList2.filter(function (item) {
        // this.seletedArr.map(item => item.id)
        return _this3.seletedArr.map(function (items) {
          return items.v_uid;
        }).indexOf(item.v_uid) === -1;
      });
      console.log(this.tableList2);
    },
    // 添加到右侧操作
    toRight: function toRight() {
      this.tableList2 = this.tableList2.concat(this.selectArr);
      this.tableList2 = deteleObject(this.tableList2);
      console.log(this.tableList2);
    },
    // 获取左侧销售数据
    getMenu: function getMenu() {
      var _this4 = this;
      _getMenu().then(function (res) {
        _this4.menus = res.data;
      });
    },
    getData: function getData() {
      var _this5 = this;
      getList(this.query).then(function (res) {
        _this5.tableList = res.data;
        _this5.list = res.data;
        _this5.pages = res.pages;
        console.log(_this5.tableList);
      });
    },
    // 左侧人员选择
    handleSelectionChange: function handleSelectionChange(data) {
      console.log(data);
      this.selectArr = data;
    },
    // 右侧人员选择
    handleSelectionChange2: function handleSelectionChange2(data) {
      console.log(data);
      this.seletedArr = data;
    },
    // 人员搜索
    handleFilter: function handleFilter() {
      this.getData();
    },
    // 选择确认
    confirm: function confirm() {
      var _this6 = this;
      if (this.tableList2.length === 0) {
        this.$alert('已选人员列表为空，请先选择人员！');
        return;
      }
      // this.query.wuids = this.tableList2.map(res => res.id)
      // if (this.$route.query.edit && this.remindKey) {
      //   updateRemindList({ wuids: this.query.wuids, modal_remind_key: this.remindKey }).then(res => {
      //     this.$emit('getkey', res.data.modal_remind_key, this.select_number)
      //   })
      //   return
      // }
      var arrs = this.tableList2.map(function (item) {
        return item.v_uid;
      });
      toSubmit({
        vuids: arrs
      }).then(function (res) {
        _this6.$message.success('操作成功！');
        _this6.$emit('get-key', res.data.cache_key, _this6.select_number);
        _this6.dialogTableVisible = false;
      });
    },
    // 选择左侧菜单时操作
    handlePostData: function handlePostData(obj) {
      // this.$refs.departmentData.setCheckedKeys([])
      this.query.organize_ids = this.$refs.postData.getCheckedNodes(false, false).map(function (res) {
        return res.id;
      });
      this.getData();
    }
  }
};